"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.caseStudiesListDictionary = void 0;
exports.caseStudiesListDictionary = {
    applyBtnLabel: 'Filter - Apply',
    cancelBtnLabel: 'Filter - Cancel',
    closeBtnLabel: 'Filter - Close',
    doneBtnLabel: 'Filter - Done',
    filterBtnLabel: 'Filter - Filter',
    filterHeaderDefaultLabel: 'Filter - Filter by',
    numberOfItems: 'Number of results',
    resetBtnLabel: 'Filter - Clear Filters',
    showLessBtnLabel: 'Show less',
    showMoreBtnLabel: 'Show more',
    sortBtnLabel: 'Sort - Sort by',
    sortStartDateAscLabel: 'Sort - Oldest first',
    sortStartDateDescLabel: 'Sort - Newest first',
    sortTitleAscLabel: 'Sort - Name A-Z',
    sortTitleDefaultLabel: 'Sort - Default Sorting',
    sortTitleDescLabel: 'Sort - Name Z-A',
    sortAllLabel: 'Sort - All',
    sortMenuOpenLabel: 'Sort - Open sort menu',
    sortMenuCloseLabel: 'Sort - Close sort menu',
};
